// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mhBzzgpNWv2JWl {
  padding: var(--ds-space-150, 10px);
}
.mhBzzgpNWv2JWl .r6dzJOoLt1diP6 {
  font-weight: var(--ds-font-weight-regular, 400);
}
.mhBzzgpNWv2JWl .uMnsEizZPgoOVD {
  margin-top: var(--ds-space-500, 40px);
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin-top: var(--ds-space-300, 25px);
}
.mhBzzgpNWv2JWl .NeNJjCZwZ8i_FD {
  font-weight: var(--ds-font-weight-regular, 400);
  display: flex;
  align-items: center;
  min-height: 64px;
  color: var(--ds-text, #172b4d);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.mhBzzgpNWv2JWl .k4_pR1tApyXpNo {
  margin-top: 52px;
  color: var(--ds-text, #172b4d);
  font-size: 35px;
  letter-spacing: -0.01em;
  line-height: 40px;
  font-weight: var(--ds-font-weight-semibold, 600);
  overflow-wrap: break-word;
  font-size: 26px;
}
.mhBzzgpNWv2JWl .Qa5bY5J5zV9E9h,
.mhBzzgpNWv2JWl .Z4LDUHxOmWRoV7,
.mhBzzgpNWv2JWl .PxgKjH5ttU75lI {
  font-weight: var(--ds-font-weight-regular, 400);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.mhBzzgpNWv2JWl .Z4LDUHxOmWRoV7 {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  margin: var(--ds-space-400, 32px) var(--ds-space-300, 25px) var(--ds-space-300, 25px) 30px;
}
.mhBzzgpNWv2JWl:nth-last-child(2) {
  border-top: 3px solid var(--ds-border-discovery, #8270db);
  border-right: 4px solid var(--ds-border-discovery, #8270db);
  border-left: 3px solid var(--ds-border-discovery, #8270db);
}
.mhBzzgpNWv2JWl:nth-last-child(2) .uMnsEizZPgoOVD {
  margin-top: var(--ds-space-050, 3px);
}
.mhBzzgpNWv2JWl:nth-last-child(2)::before {
  margin-top: var(--ds-space-250, 20px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  font-weight: var(--ds-font-weight-semibold, 600);
  content: attr(data-value);
  position: relative;
  top: var(--ds-space-negative-200, -15px);
  width: 85px;
  height: 24px;
  padding: var(--ds-space-075, 5px);
  border-radius: var(--ds-border-radius-050, 2px);
  background-color: var(--ds-border-discovery, #8270db);
  color: var(--ds-text-inverse, #ffffff);
  line-height: inherit;
}
`, ""]);
// Exports
export var planCell = `mhBzzgpNWv2JWl`;
export var purchase = `r6dzJOoLt1diP6`;
export var name = `uMnsEizZPgoOVD`;
export var info = `NeNJjCZwZ8i_FD`;
export var price = `k4_pR1tApyXpNo`;
export var frequency = `Qa5bY5J5zV9E9h`;
export var pricingVaries = `Z4LDUHxOmWRoV7`;
export var currentPlan = `PxgKjH5ttU75lI`;
export default ___CSS_LOADER_EXPORT___;
